import React, { useState } from 'react';
import Paper from '@material-ui/core/Paper';
import { Collapse, Input, Button, Row, Col, message as AlertAnt } from 'antd';
import ListUsersWithSelect from '../../components/ListUsersWithSelect';
import { instanceAxios } from '../../InstanceAxios';

function Notificacao() {
  AlertAnt.config({
    top: 100,
  });
  const { Panel } = Collapse;
  const { TextArea } = Input;
  const [inputNotificacaoParaTodos, setInputNotificacaoParaTodos] =
    useState('');
  const [inputNotificacaoParaIds, setInputNotificacaoParaIds] = useState('');
  const [arrayUserIds, setArrayUserIds] = useState([]);
  const [loading, setLoading] = useState(false);

  const sendNotification = async (message, arrayWithIds) => {
    setLoading(true);
    await instanceAxios(localStorage.getItem('toobiauth'))
      .post(`/enviarpushnotification`, {
        mensagem: message,
        arrayIds: arrayWithIds.map((a) => a.toString()),
      })
      .then((res) => {
        setInputNotificacaoParaTodos('');
        setInputNotificacaoParaIds('');
        setArrayUserIds([]);
        setLoading(false);
        AlertAnt.success('Notificação enviada com sucesso.', 10);
      })
      .catch((err) => {
        setLoading(false);
        AlertAnt.warn(
          'Houve um erro de comunicação, verifique sua conexão e tente novamente mais tarde.',
          10
        );
      });
  };

  return (
    <div style={{ margin: 20 }}>
      <link
        rel="stylesheet"
        href="https://fonts.googleapis.com/css?family=Roboto:300,400,500,700&display=swap"
      />
      <Paper
        elevation={3}
        style={{
          marginBottom: 10,
          paddingTop: 20,
          paddingBottom: 20,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <h1
          style={{
            fontSize: 25,
            h1Align: 'center',
            fontWeight: 'bold',
            color: '#030d4f',
          }}
        >
          Notificar Usuário
        </h1>
      </Paper>
      <Collapse accordion>
        <Panel header="Enviar notificação para uma lista de usuários" key="1">
          <ListUsersWithSelect
            setArrayUserIds={(array) => setArrayUserIds(array)}
            arrayUserIds={arrayUserIds}
          />
          <div style={{ marginTop: 10 }} />
          <TextArea
            rows={4}
            value={inputNotificacaoParaIds}
            onChange={(event) => setInputNotificacaoParaIds(event.target.value)}
          />
          <Row align="bottom" style={{ marginTop: 10 }}>
            <Col span={8} />
            <Col span={8}>
              <Button
                loading={loading}
                block
                onClick={() =>
                  sendNotification(inputNotificacaoParaIds, arrayUserIds)
                }
              >
                Enviar Mensagem
              </Button>
            </Col>
            <Col span={8} />
          </Row>
        </Panel>
        <Panel header="Enviar notificação para todos os usuários" key="2">
          <TextArea
            rows={4}
            onChange={(event) =>
              setInputNotificacaoParaTodos(event.target.value)
            }
            value={inputNotificacaoParaTodos}
          />
          <Row align="bottom" style={{ marginTop: 10 }}>
            <Col span={8} />
            <Col span={8}>
              <Button
                loading={loading}
                block
                onClick={() => sendNotification(inputNotificacaoParaTodos, [])}
              >
                Enviar Mensagem
              </Button>
            </Col>
            <Col span={8} />
          </Row>
        </Panel>
      </Collapse>
    </div>
  );
}

export default Notificacao;
